import { Stack, type StackProps } from "@mui/material";
export const DesignationContainer = (props: StackProps) => {
  return <Stack gap={0} direction="row" alignItems="center" {...props} />;
};
